import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
// material-ui
import { useTheme } from '@mui/material/styles';

import {
    Avatar,
    Button,
    Grid,
    InputAdornment,
    Menu,
    MenuItem,
    OutlinedInput,
    Pagination,
    Typography,
    TextField,
    ButtonBase
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import axios from 'axios';
// project imports

import MainCard from 'ui-component/cards/MainCard';
import { gridSpacing } from 'store/constant';

import Loader from 'ui-component/Loader';

import CustomDateTime from 'components/DateTime/CustomDateTime';

// assets
import { IconSearch } from '@tabler/icons';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';

import useAuth from 'hooks/useAuth';

import { v4 as uuidv4 } from 'uuid';

import { openSnackbar } from 'store/slices/snackbar';

import { useDispatch, useSelector } from 'store';
import { changePassword, getManager, startLoading } from 'store/slices/company-user';

// ==============================|| USER LIST STYLE 2 ||============================== //

const UserAccountProfileChangePassword = () => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const [oldPassword, setOldPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');

    const [email, setEmail] = useState('');

    const { user } = useAuth();

    const [date, setDate] = React.useState(new Date());

    const { loading, manager, error } = useSelector((state) => state.companyUsers);

    useEffect(() => {
        if (manager === null) {
            dispatch(getManager(user.email));
        }
    }, [manager]);
    const navigate = useNavigate();

    useEffect(() => {
        if(error) {
        dispatch(
            openSnackbar({
                open: true,
                message: error?.message === 'Incorrect username or password.' ? 'Old password is incorrect' : error?.message,
                variant: 'alert',
                alert: {
                    color: 'error'
                },
                close: true
            })
        );
        }
    // last
    }, [error]);

    const submit = async () => {
        if (oldPassword === '' || newPassword === '') {
            dispatch(
                openSnackbar({
                    open: true,
                    message: error,
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: true
                })
            );
        } else {
            // dispatch(startLoading());
            const data = {
                oldPassword,
                newPassword
            };
            console.log('user loaded', manager, data);
            dispatch(changePassword(oldPassword, newPassword, navigate));
        }
    };

    useEffect(() => {
        console.log('changePassword', error?.message, loading);
    }, [error])

    return (
        <MainCard
            title={
                <Grid container justifyContent="space-between" alignItems="center" spacing={gridSpacing}>
                    <Grid item>
                        <Typography variant="h3">Change Password</Typography>
                    </Grid>
                </Grid>
            }
        >
            <Grid item md={6} xs={12}>
                <TextField
                    fullWidth
                    id="outlined-multiline-flexible"
                    label="Old Password"
                    value={oldPassword}
                    onChange={(event) => {
                        setOldPassword(event.target.value);
                    }}
                />
            </Grid>
            <Grid item md={6} xs={12} style={{ marginTop: 20 }}>
                <TextField
                    fullWidth
                    id="outlined-multiline-flexible"
                    label="New Password"
                    value={newPassword}
                    onChange={(event) => {
                        setNewPassword(event.target.value);
                    }}
                />
            </Grid>

            <Grid item lg={2} md={4} sm={6} xs={12} style={{ marginTop: 20 }}>
                <Button
                    onClick={() => {
                        submit();
                    }}
                    disabled={loading}
                    variant="outlined"
                    fullWidth
                    size="small"
                    sx={{ minWidth: 120 }}
                    startIcon={<AddIcon />}
                >
                    {!loading ? 'Update' : 'Updating...'}
                </Button>
            </Grid>
            {loading && <Loader />}
        </MainCard>
    );
};

export default UserAccountProfileChangePassword;
